import { css } from 'styled-components';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
var slideAlignCSS = inlineMediaQueryMixin('slideAlign', function (_ref) {
  var slideAlign = _ref.slideAlign;
  return css(["scroll-snap-align:", ";"], slideAlign);
});
var slideWidthCSS = inlineMediaQueryMixin('slideWidth', function (_ref2) {
  var slideWidth = _ref2.slideWidth;
  return css(["flex-basis:", ";"], slideWidth > 0 ? slideWidth + "px" : 'auto');
});

/** @class CarouselSlideMixin */
/** @method */
export var CarouselSlideMixin = function CarouselSlideMixin(props) {
  return css(["flex-grow:0;flex-shrink:0;", " ", ""], slideAlignCSS(props), slideWidthCSS(props));
};